import React from 'react';
import { Loader2, AlertTriangle } from 'lucide-react';

export default function ReviewButton({ disabled, onClick, submitting, warning, leftSlot }) {
  return (
    <div className="px-4 md:px-6 py-3 md:py-4 border-t border-[#EEE9FB] flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      <div className="flex-1 flex items-center gap-2 flex-wrap">
        {leftSlot}
        {warning && (
          <span
            data-testid="length-warning-pill"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#FFF4E5] text-[#B7721B] text-[11.5px] font-semibold"
          >
            <AlertTriangle size={12} />
            {warning}
          </span>
        )}
      </div>
      <button
        onClick={onClick}
        disabled={disabled}
        data-testid="review-btn"
        className={`px-6 py-2.5 rounded-full text-[14px] font-semibold transition-all inline-flex items-center justify-center gap-2 ${
          disabled
            ? 'bg-[#D6CFEF] text-white cursor-not-allowed'
            : 'bg-[#5B4FE8] text-white hover:bg-[#4A3FD9] shadow-md'
        }`}
      >
        {submitting && <Loader2 size={14} className="animate-spin" />}
        {submitting ? 'Saving…' : 'Review'}
      </button>
    </div>
  );
}
